/**
 * Main entry point for the inventor form functionality
 */
document.addEventListener('DOMContentLoaded', function() {
    // Initialize the form manager
    new InventorFormManager();
});
